import { gql } from '@/__generated__';

export const toggleLiveActiveDocument = gql(/* GraphQL */ `
  mutation ToggleLiveActive($where: LiveWhereUniqueInput!) {
    toggleLiveActive(where: $where) {
      id
      active
    }
  }
`);

export const deleteLiveDocument = gql(/* GraphQL */ `
  mutation DeleteLive($where: LiveWhereUniqueInput!) {
    deleteLive(where: $where) {
      id
    }
  }
`);

export const upsertLiveDocument = gql(/* GraphQL */ `
  mutation UpsertLive(
    $where: LiveWhereUniqueInput!
    $create: LiveCreateInput!
    $update: LiveUpdateInput!
  ) {
    upsertLive(where: $where, create: $create, update: $update) {
      id
    }
  }
`);

export const sendCheckoutLinksDocument = gql(/* GraphQL */ `
  mutation SendCheckoutLinks($where: LiveWhereUniqueInput!) {
    sendCheckoutLinks(where: $where)
  }
`);
